import React, { useState, useMemo, useEffect } from 'react'
import styles from './ViewFeedbackDetails.module.css';
import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';

import Card from 'react-bootstrap/Card';
import { CardHeader } from 'react-bootstrap';
import DatatTable from '../../basic-component/TableNoStyle';
const ResolutionDetails = ({ data }) => {
  const { t } = useTranslation();
  // table data
  const columnData = useMemo(
    () => [

      {
        accessorKey: 'resolverName',
        header: t('feedbackDetails.resolverName.text'),
      },
      {
        accessorKey: 'rootCause',
        header: t('feedbackDetails.rootCause.text'),

      },
      {
        accessorKey: 'correctiveAction',
        header: t('feedbackDetails.correctiveAction.text'),
      },
      {
        accessorKey: 'action',
        header: t('feedbackDetails.preventiveAction.text'),
        enableSorting: false,
      },
      {
        accessorKey: 'responseLogger',
        header: t('gereral.model.lable.header.responseLogger'),
        enableSorting: false,
      },
      {
        accessorKey: 'completionDate',
        header: t('feedbackDetails.completionDate.text'),
        enableSorting: false,
      },
      {
        accessorKey: 'autoClosureDate',
        header: t('feedbackDetails.autoClosureDate.text'),
        enableSorting: false,
      },
      {
        accessorKey: 'status',
        header: t('label.new.survey.status'),
        enableSorting: false,
      },
      {
        accessorKey: "rating",
        header: t("general.label.rating"),
        enableRowSpan: true,
      },
      {
        accessorKey: "time",
        header: t("Time"),
        enableRowSpan: true,
      },
      {
        accessorKey: "reason",
        header: t("login.msg.reason"),
      },
    ],
    [t],
  );
 
  useEffect(() => {
    // Your logic for handling data and UI interactions
  }, [data]);

  if (!data || !data.resolverDetails) {
    return <p>Loading...</p>;
  }




  const generateAppropriateDate = (value) => {
    if (value === undefined || value === null) {
      return "N/A";
    } else {
      const date = new Date(value);
      /*const formattedDate =
        date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }) +
        ' ' +
        date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
        });*/

      const formattedDate = [
          ('0' + date.getDate()).slice(-2), // Day
          ('0' + (date.getMonth() + 1)).slice(-2), // Month
          date.getFullYear(), // Year
      ].join('-') + ' ' + date.toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit' });

      return formattedDate;
    }
  };

  const getAutoClosureDate = (feedbackDetails) => {
    if (!feedbackDetails) {
      return 'N/A';
    }
    const actionValue = Number(feedbackDetails.actionValue);
    if (actionValue > 0 && feedbackDetails.closureStatus === 'A') {
      return generateAppropriateDate(feedbackDetails.closureTarget);
    }
    return 'N/A';
  };

  const tableStyles = {
    width: " 100%",
    height: "auto",
    minWidth: "0"
  }


  const parseHTML = (htmlString) => {
    return <span dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };
  const rowsData = [];
  const autoClosureDate = getAutoClosureDate(data?.feedbackDetails);

  data && data.resolverDetails.map((item, index) => {

    if (item.receipt?.updateDate && !item.receipt.updateDate.toString().includes('/')) {
        const date = new Date(item.receipt.updateDate); // works with timestamp or ISO string
        if (!isNaN(date)) {
          const pad = (n) => n.toString().padStart(2, '0');
          const formattedDate = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
          item.receipt.updateDate = formattedDate;
        }
      }


      if (item.receipt?.feedbackSatisfaction?.reason) {
        if (typeof item.receipt.feedbackSatisfaction.reason === "string") {
          try {
            console.log(item.receipt.feedbackSatisfaction.reason);
            const parsedReason = JSON.parse(item.receipt.feedbackSatisfaction.reason);
            if (Array.isArray(parsedReason)) {
              debugger;
              parsedReason.map((reasonItem, index) => {
                console.log(reasonItem);   
                item.receipt.feedbackSatisfaction.reason = reasonItem;
                
              });
            } 
          }catch (error) {
            console.error("Error parsing JSON:", error);
          }

        }
      }

    rowsData.push({
      resolverName: item.user.firstName + " " + item.user.lastName,
      rootCause: item.rootCause,
      correctiveAction: item.correctiveAction,
      action: item.preventiveAction,
      responseLogger: parseHTML(item.responseToLogger),
      completionDate: generateAppropriateDate(item.completionDate),
      autoClosureDate: autoClosureDate,
      status: item.status,
      //rating: item.receipt.feedbackSatisfaction.id,
      time: item.receipt.updateDate,
      reason : item.receipt?.feedbackSatisfaction?.reason?.deSatisfactionReason,
      rating : (
                    <button
                      type="button"
                      className="btn-rating after-rated py-1 lh-normal btn btn-secondary btn-sm m-0"
                    >
                      <span>
                        {item.receipt?.feedbackSatisfaction?.id < 10 ? (
                          <>
                            {Array.from(
                              { length: item.receipt?.feedbackSatisfaction?.id },
                              (_, i) => (
                                <i
                                  className={`ti ti-star-filled star-${item.receipt?.feedbackSatisfaction?.id} icon-small fs-6`}
                                  key={i}
                                ></i>
                              )
                            )}
                            {Array.from(
                              {
                                length:
                                  5 - (item.receipt?.feedbackSatisfaction?.id || 0),
                              },
                              (_, j) => (
                                <i
                                  className={`ti ti-star star-${item.receipt?.feedbackSatisfaction?.id} icon-small fs-6`}
                                  key={j}
                                  
                                ></i>
                              )
                            )}
                          </>
                        ) : item.receipt?.feedbackSatisfaction?.id === 100 ? (
                          <>
                            {Array.from({ length: 5 }, (_, i) => (
                              <i
                                className={`ti ti-star-filled star-5 icon-small fs-6`}
                                key={i}
                               
                              ></i>
                            ))}
                          </>
                        ) : (
                          <>
                            {Array.from({ length: 3 }, (_, i) => (
                              <i
                                className={`ti ti-star-filled star-3 icon-small fs-6`}
                                key={i}
                                
                              ></i>
                            ))}
                            <i
                              className={`ti ti-star-filled star-3 icon-small fs-6`}
                              
                            ></i>
                            <i
                              className={`ti ti-star-filled star-3 icon-small fs-6`}
                              
                            ></i>
                            <i
                              className={`ti ti-star-filled star-3 icon-small fs-6`}
                              
                            ></i>
                          </>
                        )}
                      </span>
                    </button>
                  ),
    })

  });

  if (data) {
    // const resolverDetails = data.resolverDetails.map((item, index) => (
    //   <TableRow key={index}>
    //     <TableCell>{item.user.firstName + " " + item.user.lastName}</TableCell>
    //     <TableCell>{item.rootCause}</TableCell>
    //     <TableCell>{item.correctiveAction}</TableCell>
    //     <TableCell>{item.preventiveAction}</TableCell>
    //     <TableCell dangerouslySetInnerHTML={{ __html: item.responseToLogger }} />
    //     <TableCell>{generateAppropriateDate(item.completionDate)}</TableCell>
    //     <TableCell>{item.status}</TableCell>
    //   </TableRow>
    // ));

    let responseToLoggerDetails = (
      <List style={{ listStyleType: 'disc' }}>
        {data.resolverDetails &&
          data.resolverDetails.length > 0 &&
          data.resolverDetails.map((resolver, index) => (
            <ListItem key={index}>
              <ListItemText primary={resolver.responseToLogger} />
            </ListItem>
          ))}
      </List>
    );

    // let resolverVsCustomerReply = (
    //   <TableContainer component={Paper} style={{ marginTop: '20px' }}>
    //     <Table>
    //       <TableHead>
    //         <TableRow>
    //           <TableCell>Response To Customer</TableCell>
    //           <TableCell>Reopen/Unsatisfied Reason</TableCell>
    //         </TableRow>
    //       </TableHead>
    //       <TableBody>
    //         {data.resolverDetails && data.resolverDetails.length > 0 ? (
    //           data.reopenReasonList && data.reopenReasonList.length > 0 ? (
    //             data.resolverDetails.map((item, index) => (
    //               <TableRow key={index}>
    //                 <TableCell>{item.responseToLogger}</TableCell>
    //                 <TableCell>
    //                   <FormControl fullWidth>
    //                     <InputLabel id={`reopen-reason-label-${index}`}>Reopen Reason</InputLabel>
    //                     <Select
    //                       labelId={`reopen-reason-label-${index}`}
    //                       value={0} // Replace with actual value from state or data
    //                       label="Reopen Reason"
    //                     >
    //                       {data.reopenReasonList.map((reason, reasonIndex) => (
    //                         <MenuItem key={reasonIndex} value={reason.id}>
    //                           {reason.reason}
    //                         </MenuItem>
    //                       ))}
    //                     </Select>
    //                   </FormControl>
    //                 </TableCell>
    //               </TableRow>
    //             ))
    //           ) : (
    //             data.resolverDetails.map((item, index) => (
    //               <TableRow key={index}>
    //                 <TableCell>{item.responseToLogger}</TableCell>
    //                 <TableCell>{/* JSX elements when reopen reason list is not available */}</TableCell>
    //               </TableRow>
    //             ))
    //           )
    //         ) : null}
    //       </TableBody>
    //     </Table>
    //   </TableContainer>
    // );

    let satisfactionDetails = null;

    if (data.feedbackSatisfactionDetails && data.feedbackSatisfactionDetails.length > 0) {
      const option = data.feedbackSatisfactionDetails.map((item, index) => (
        <MenuItem key={index} value={item.id}>
          {item.satisfactionLevel}
        </MenuItem>
      ));

      satisfactionDetails = (
        <FormControl fullWidth style={{ marginTop: '20px' }}>
          <InputLabel id="satisfactionLevel-label">{t('general.lable.satisfactionLevel.text')}</InputLabel>
          <Select
            labelId="satisfactionLevel-label"
            value={0} // Replace with actual value from state or data
            label={t('general.lable.satisfactionLevel.text')}
          >
            {option}
          </Select>
        </FormControl>
      );
    }

    // return (
    //   <div>
    //     {/* <TableContainer component={Paper} className={styles.customBody}>
    //       <Table>
    //         <TableHead>
    //           <TableRow style={{ backgroundColor: '#867FA1' }}>
    //             <TableCell className={styles.tableHeight}>{t('feedbackDetails.resolverName.text')}</TableCell>
    //             <TableCell className={styles.tableHeight}>{t('feedbackDetails.rootCause.text')}</TableCell>
    //             <TableCell className={styles.tableHeight}>{t('feedbackDetails.correctiveAction.text')}</TableCell>
    //             <TableCell className={styles.tableHeight}>{t('feedbackDetails.preventiveAction.text')}</TableCell>
    //             <TableCell className={styles.tableHeight}>Response To Logger</TableCell>
    //             <TableCell className={styles.tableHeight}>{t('feedbackDetails.completionDate.text')}</TableCell>
    //             <TableCell className={styles.tableHeight}>{t('label.new.survey.status')}</TableCell>
    //           </TableRow>
    //         </TableHead>
    //         <TableBody>{resolverDetails}</TableBody>
    //       </Table>
    //     </TableContainer> */}

    //     {/* <div style={{ marginTop: '20px' }}>{responseToLoggerDetails}</div> */}

    //     {/* Render resolver vs customer reply */}
    //     {/* {resolverVsCustomerReply} */}

    //     {/* Render satisfaction details */}
    //     {/* {satisfactionDetails} */}
    //   </div>
    // );


    return (
      <Card className='overflow-hidden'>
        <DatatTable tableStyles={tableStyles} tableData={{ columnData: columnData, rowsData: rowsData }} />
      </Card>
    )
  }

};

export default ResolutionDetails;
